import React, { useState } from 'react';
import { Page } from 'components/Page';
import BookingForm from './BookingForm';
import SiteDetailSection from './SiteDetailsSection';
import { useGlobalContext } from 'state/GlobalContext';
import { CardBox } from 'page-components/CardBox';
import { useNavigate } from 'react-router-dom';
import { Reservation } from 'models';
import { Box, css, Flex } from 'theme-ui';
import styled from '@emotion/styled';

const BookingPage: React.FC = () => {
  const navigate = useNavigate();
  const [{ state }] = useGlobalContext();
  const [formValues, setFormValues] = useState<Reservation>(state.reservation);
  const [canBook, setCanBook] = useState(false);
  const [isLongTerm, setIsLongTerm] = useState(false);
  const hasVehicleDetails = state.siteType?.universalSiteType?.hasVehicleDetails;
  const hasAvailableSites = state.quote?.availableSites > 0;

  React.useEffect(() => {
    const res = Reservation.new(formValues);
    let longTerm = Reservation.Model.isLongTerm(res);
    setIsLongTerm(longTerm);
    const reqValues = [res.dateRange, res.visitorsInfo, res.siteTypeId];
    if (hasVehicleDetails) {
      reqValues.push(res.vehicleType, res.vehicleLengthRange);
    }
    const condition = reqValues.map(item => item && true).every(bool => bool);
    setCanBook(condition && !longTerm && hasAvailableSites);
  }, [formValues, hasVehicleDetails, hasAvailableSites]);

  const onBookNow = () => {
    navigate('/payment');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const spotsLegend = (
    <Flex sx={{gap: 3}}>
      <Box mt={2}>
        <strong>3 spots left</strong> for this cabin type for the dates you have choosen
      </Box>
      <Image src="/assets/limited-spots.svg" alt="Limited spot left" />
    </Flex>
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const guaranteeLeyend = (
    <RoundedBox mt={4} p={3} mx={[3, 0]}>
      <Image src="/assets/shield.svg" />
      <Box>
        <strong>Lowest Price Guarantee</strong><br />
        Best price available at the time of your booking
      </Box>
    </RoundedBox>
  )

  const onChange = (value: Reservation) => {
    setFormValues(value);
  }

  return (
    <Page title="Checkout">
      <CardBox md={14}>
        <BookingForm onChange={onChange} />
      </CardBox>

      <CardBox md={10}>
        <SiteDetailSection formValues={formValues} onBookNow={onBookNow} canBook={canBook} isLongTerm={isLongTerm} />
      </CardBox>
    </Page>
  );
};

const Image = styled('img')();

const RoundedBox = styled(Box)(css({
  border: '1px solid #ddd',
  display: 'flex',
  alignItems: 'center',
  gap: 3,
  borderRadius: 8,
}));

export default BookingPage;
